import { Typography, TypographyProps } from '@saucelabs/ds-typography';
import React, { FC } from 'react';

import Truncate from '../common/Truncate';

interface MetadataBaseProps {
  hide?: boolean;
  label?: string;
  secondLabel?: string;
  icon?: JSX.Element;
  truncate?: boolean;
  hideTooltip?: boolean;
}

type MetadataProps = (
  MetadataBaseProps & Required<Pick<MetadataBaseProps, 'label'>> |
  MetadataBaseProps & Required<Pick<MetadataBaseProps, 'secondLabel'>> |
  MetadataBaseProps & Required<Pick<MetadataBaseProps, 'icon'>>
) & Omit<TypographyProps, 'children'>

const Metadata: FC<MetadataProps> = ({
  hide = false,
  icon,
  label,
  secondLabel,
  truncate,
  hideTooltip,
  ...rest
}) => {
  if (hide) {
    return null;
  }
  const labelComponent = truncate ? (
    <Truncate
      {...rest}
      disableSpacing
      hideTooltip={hideTooltip}
      text={label}
      variant="body"
    >
      {label}
    </Truncate>
  ) : (
    <Typography
      {...rest}
      disableSpacing
      variant="body"
    >
      {label}
      {label && secondLabel && <span className="ml-2" />}
      {secondLabel}
    </Typography>
  );

  return (
    <>
      <div className="flex flex-shrink-0">
        {icon}
      </div>
      {(label || secondLabel) ? labelComponent : null}
    </>
  );
};

export default Metadata;
